import { useCallback } from 'react';
import { useTasks } from '@battleops/client/src/context/TaskContext';
import { useDepartments } from '@battleops/client/src/context/DepartmentContext';

/** Start a task the way the phone's Home does: be on the clock in its project (unless its department doesn't
 *  clock), then point the timer at it. */
export function useStartTask() {
  const { clockedIn, clockIn, switchClockProject, startCard } = useTasks();
  const { deptForProject } = useDepartments();
  return useCallback((t) => {
    const pid = t.projectId || null;
    const clocks = !pid || deptForProject(pid).clock !== false;
    if (clocks) {
      if (!clockedIn) clockIn(pid);
      else if (pid && clockedIn.projectId !== pid) switchClockProject(pid);
    }
    setTimeout(() => startCard(t.id), 50);
  }, [clockedIn, clockIn, switchClockProject, startCard, deptForProject]);
}

export const dayLabel = (date, today) => {
  if (!date) return 'Backlog';
  if (date === today) return 'Today';
  const d = new Date(`${date}T12:00:00`);
  const t = new Date(`${today}T12:00:00`);
  const diff = Math.round((d - t) / 86400000);
  if (diff === 1) return 'Tomorrow';
  if (diff === -1) return 'Yesterday';
  return d.toLocaleDateString(undefined, { weekday: 'short', month: 'short', day: 'numeric' });
};

export const hhmm = (ms) => (ms ? new Date(ms).toLocaleTimeString(undefined, { hour: 'numeric', minute: '2-digit' }) : '');
export const money = (n) => (n == null ? '—' : `$${Number(n).toLocaleString(undefined, { maximumFractionDigits: 0 })}`);
export const isoAddDays = (date, n) => {
  const d = new Date(`${date}T12:00:00`); d.setDate(d.getDate() + n);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
};
